import { SVGProps } from "react";

export function FeeManagementIcon({
  width = 24,
  height = 24,
  viewBox = "0 0 24 24",
  fill = "none",
  stroke = "#ADB3BC",
  strokeWidth = 1,
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns={xmlns}
      {...props}
    >
      <g clip-path="url(#clip0_3005_395)">
        <path
          d="M1.65359 8.93669H11.5751V10.5903H1.65359V8.93669ZM0 4.80273H8.26795V6.45632H0V4.80273Z"
          fill={stroke}
        />
        <path
          d="M23.0833 9.43793L20.6029 3.65037C20.5393 3.50161 20.4333 3.37483 20.2983 3.28575C20.1632 3.19668 20.0049 3.14924 19.8431 3.14933H17.3627V1.49574C17.3627 1.27646 17.2756 1.06616 17.1206 0.911108C16.9655 0.756054 16.7552 0.668945 16.5359 0.668945H3.3072V2.32254H15.7091V12.7038C15.3324 12.9225 15.0027 13.2137 14.739 13.5605C14.4754 13.9074 14.283 14.3029 14.1729 14.7245H8.97736C8.77614 13.9451 8.29753 13.2658 7.63134 12.8141C6.96511 12.3623 6.15699 12.169 5.35848 12.2704C4.55996 12.3719 3.82582 12.761 3.2937 13.365C2.76159 13.969 2.46802 14.7463 2.46802 15.5513C2.46802 16.3562 2.76159 17.1335 3.2937 17.7375C3.82582 18.3415 4.55996 18.7306 5.35848 18.8321C6.15699 18.9335 6.96511 18.7402 7.63134 18.2885C8.29753 17.8367 8.77614 17.1574 8.97736 16.3781H14.1729C14.3528 17.0876 14.7641 17.717 15.3419 18.1665C15.9196 18.6161 16.6307 18.8602 17.3627 18.8602C18.0948 18.8602 18.8059 18.6161 19.3836 18.1665C19.9613 17.717 20.3726 17.0876 20.5525 16.3781H22.3235C22.5428 16.3781 22.7531 16.2909 22.9081 16.1359C23.0632 15.9808 23.1503 15.7705 23.1503 15.5513V9.76369C23.1503 9.65169 23.1275 9.54083 23.0833 9.43793ZM5.78757 17.2048C5.46055 17.2048 5.14084 17.1079 4.86891 16.9261C4.59698 16.7445 4.38504 16.4862 4.25987 16.1841C4.1347 15.8819 4.10196 15.5494 4.16579 15.2287C4.22958 14.9079 4.38706 14.6133 4.61833 14.382C4.84957 14.1507 5.1442 13.9932 5.46498 13.9294C5.78575 13.8656 6.11823 13.8984 6.42038 14.0235C6.72253 14.1487 6.98081 14.3606 7.1625 14.6326C7.34418 14.9045 7.44119 15.2242 7.44119 15.5513C7.44072 15.9897 7.26639 16.41 6.95637 16.72C6.64636 17.03 6.226 17.2044 5.78757 17.2048ZM17.3627 4.80294H19.2974L21.0701 8.93689H17.3627V4.80294ZM17.3627 17.2048C17.0357 17.2048 16.716 17.1079 16.444 16.9261C16.1721 16.7445 15.9602 16.4862 15.835 16.1841C15.7099 15.8819 15.6771 15.5494 15.7409 15.2287C15.8047 14.9079 15.9622 14.6133 16.1934 14.382C16.4247 14.1507 16.7194 13.9932 17.0401 13.9294C17.3609 13.8656 17.6933 13.8984 17.9955 14.0235C18.2977 14.1487 18.5559 14.3606 18.7376 14.6326C18.9193 14.9045 19.0163 15.2242 19.0163 15.5513C19.0159 15.9897 18.8415 16.41 18.5315 16.72C18.2215 17.03 17.8012 17.2044 17.3627 17.2048ZM21.4967 14.7245H20.5525C20.3703 14.0162 19.9584 13.3885 19.3811 12.9396C18.8039 12.4908 18.094 12.2461 17.3627 12.2441V10.5905H21.4967V14.7245Z"
          fill={stroke}
        />
      </g>
      <defs>
        <clipPath id="clip0_3005_395">
          <rect
            width="23.3333"
            height="18.1921"
            fill="white"
            transform="translate(0 0.668945)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
